"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _colors = require("./colors");
var Colors = {
  hover: _colors.FullPalette.IRIS_E25,
  selected: _colors.FullPalette.GREY_E500,
  error: _colors.FullPalette.POPPY_600
};
var Tokens = {
  colors: Colors
};
var _default = exports["default"] = Tokens;